import type { Table } from '@wmt/content-blocks'
import type { PlayerRoster } from '~/types'
import { toFloatByPath } from '~/statistics/utils/toFloatByPath'
import { joinFieldsByPaths } from '~/statistics/utils/joinFieldsByPaths'
import { defaultBodyCells, defaultColumns } from '~/statistics/playerRosters/aliases'
import { getSortAsNumber } from '~/shared/lib/sorts'
import { StatisticRootKey } from '~/enums/statistic-root-key'
import type { CellsReturnDataType } from '~/statistics/playerRosters/index'
import type { IndividualTableSchema } from '~/statistics/team/individual'

export const columns: Table.Cell<PlayerRoster.Model>[] = [
  { content: 'Pct', sort: true },
  { content: 'Made-Att', sort: true },
  { content: '01-19', sort: true },
  { content: '20-29', sort: true },
  { content: '30-39', sort: true },
  { content: '40-49', sort: true },
  { content: '50+', sort: true },
  { content: 'Lng', sort: true },
  { content: 'Blkd', sort: true },
]

export const cells = (type: StatisticRootKey = StatisticRootKey.Statistics): CellsReturnDataType => ([
  { content: (player: PlayerRoster.Model) => toFloatByPath(player, `${type}.fieldGoals.pct`), onSort: getSortAsNumber },
  { content: (player: PlayerRoster.Model) => joinFieldsByPaths(player, [`${type}.fieldGoals.made`, `${type}.fieldGoals.attempts`]) },
  { content: (player: PlayerRoster.Model) => joinFieldsByPaths(player, [`${type}.fieldGoals.made19`, `${type}.fieldGoals.attempts19`]) },
  { content: (player: PlayerRoster.Model) => joinFieldsByPaths(player, [`${type}.fieldGoals.made29`, `${type}.fieldGoals.attempts29`]) },
  { content: (player: PlayerRoster.Model) => joinFieldsByPaths(player, [`${type}.fieldGoals.made39`, `${type}.fieldGoals.attempts39`]) },
  { content: (player: PlayerRoster.Model) => joinFieldsByPaths(player, [`${type}.fieldGoals.made49`, `${type}.fieldGoals.attempts49`]) },
  { content: (player: PlayerRoster.Model) => joinFieldsByPaths(player, [`${type}.fieldGoals.made50`, `${type}.fieldGoals.attempts50`]) },
  { content: `$get(${type}.fieldGoals.longest, 0)` },
  { content: `$get(${type}.fieldGoals.blocked, 0)` },
])

export const playerRosterFieldGoalsStatsSchema: IndividualTableSchema = {
  filter: player => Boolean(player.statistics?.fieldGoals),
  schema: {
    head: {
      rows: [
        {
          cells: [
            ...defaultColumns,
            ...columns,
          ],
        },
      ],
    },
    body: {
      rows: {
        cells: [
          ...defaultBodyCells,
          ...cells() as Table.BodyCell<PlayerRoster.Model>[],
        ],
      },
    },
  },
}
